var _ = require('underscore/underscore.js');

var template = require('./SubmissionFormMembersItem.jinja');
require('./SubmissionFormMembersItem.less');


var SubmissionFormBlock = require('./SubmissionFormBlock');

module.exports = SubmissionFormBlock.extend({


    template: template,

    events: {
        'click .SubmissionFormMembersItem-delete': 'deleteItem'
    },

    initialize: function (options) {
        this.options = options || {};

        SubmissionFormBlock.prototype.initialize.call(this, options);
    },


    deleteItem: function (e) {
        this.remove();

        this.trigger('delete');
    },


    checkRequired: function () {
        return SubmissionFormBlock.prototype.checkRequired.call(this);
    },


    getData: function () {
        var data = {
            'position': this.$('select[name="position"]').val(),
            'name': this.$('input[name="name"]').val(),
            'phone': this.$('input[name="phone"]').val(),
            'email': this.$('input[name="email"]').val(),
            'address': this.$('input[name="address"]').val(),
            'address2': this.$('input[name="address2"]').val(),
            'city': this.$('input[name="city"]').val(),
            'state': this.$('input[name="state"]').val(),
            'zip': this.$('input[name="zip"]').val(),
            'country': this.$('input[name="country"]').val(),
            'affiliation': this.$('input[name="affiliation"]').val()
        };

        if (this.$('input[name="id"]').val()) {
            data.id = parseInt(this.$('input[name="id"]').val(), 10);
        }

        return data;
    }
});





//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormMembersItem.js
// module id = 121
// module chunks = 0